import { Component, Input, OnInit } from "@angular/core";
import { TooltipPosition } from "@angular/material/tooltip";
import { TranslateService } from "@ngx-translate/core";
import { DownloadOption } from "../download-upload.types";
import { DownloadUploadService } from "../download-upload.service";
import { NotifyService } from "@core/services/notify.service";
import moment from "moment";
import { DownloadFileService } from "@core/services/download-file.service";

@Component({
  selector: "app-driveb-download-file",
  templateUrl: "./download-file.component.html",
  styleUrls: ["./download-file.component.scss"],
  standalone: false
})
export class DownloadFileComponent implements OnInit {
  @Input() options: DownloadOption[];
  @Input() positionTooltip: TooltipPosition = "right";
  @Input() tooltip: string;
  @Input() disabled = false;

  fontIcon = "Bosch-Ic-download";

  constructor(
    private translateService: TranslateService,
    private downloadUploadService: DownloadUploadService,
    private notifyService: NotifyService,
    private downloadFileService: DownloadFileService
  ) {}

  ngOnInit() {
    this.setDefaultTooltip();
  }

  setDefaultTooltip() {
    if (!this.tooltip) {
      const tooltipDefault = "download-upload-file.download";
      this.tooltip = this.translateService.instant(tooltipDefault);
    }
  }

  downloadFile(option: DownloadOption): void {
    this.downloadUploadService
      .getFileData(option.endpoint, option.requestBody)
      .subscribe(
        (data) => {
          if (data.headers.get("processed-by") === "Microservice") {
            this.notifyService.showSuccessMessageWithTranslationKey(
              "report.success-track-status-export-page"
            );
            return;
          }

          const fileName = `${option.fileName}_${moment(new Date()).format(
            "YYYYMMDDhhmmss"
          )}.${option.fileType}`;
          this.downloadFileService.downloadFile(data.body, fileName);
        },
        async (error) => {
          const message = JSON.parse(await error.error.text()).message;
          this.notifyService.showErrorMessage(message);
        }
      );
  }
}
